// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabActivitiesTableManagerCell-modulecell__P4Rf_ TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "cell" }
